import React, { useState } from "react";
import styles from "./SubscribeToNewsletterForm.scss";
import cx from "../utils/cx";
import { IRapidmailNewsletterId, IRapidmailSubscriptionFormValues, IRapidmailSubscriptionResponse, IValidationMessages, sendRapidmailSubscriptionForm } from "./ContactForm/NewsletterRapidmail";
import createToast from "./MaterialUi/Toast";
import LogError from "../utils/LogError";
import useUser from "../stores/useUser";
import Switch from "./MaterialUi/Switch";
import Button from "./MaterialUi/Button";

export interface ISubscribeToNewsletterFormProps {
    className?: string;
    onSubmit: () => void;
    onCancel: () => void;
    showNextButton?: boolean;
    newsletterId: IRapidmailNewsletterId;
}

const SubscribeToNewsletterForm: React.FC<ISubscribeToNewsletterFormProps> = ({ className = '', onSubmit, onCancel, showNextButton = true, newsletterId }) => {

    const [formValues, setFormValues] = useState({} as IRapidmailSubscriptionFormValues)
    const [validationMessages, setValidationMessages] = useState({} as IValidationMessages);
    const [wantNewsletter, setWantNewsletter] = useState(false);

    const [user] = useUser();

    const handleSubmit = (ev) => {
        ev.preventDefault();
        console.log('onSubmit');

        formValues.consent_text = true;
        formValues['woechentlich'] = true;

        formValues['email'] = user.mail;
        console.log('formValues', formValues);

        if (!formValues['email']) {
            // setValidationMessages({ ...validationMessages, email: 'Bitte E-Mail-Adresse angeben' });
            createToast('Bitte E-Mail-Adresse angeben', "error");
            return;
        }


        return sendRapidmailSubscriptionForm(formValues, newsletterId).then(() => {
            // setValidationMessages({} as IValidationMessages);
            setFormValues({} as IRapidmailSubscriptionFormValues);
            createToast('Die Anmeldung wurde gespeichert.', "success");
        }).catch(e => {
            console.error(e);
            const { validation_messages } = e.responseData as IRapidmailSubscriptionResponse || {};
            if (validation_messages) {
                setValidationMessages(validation_messages);
                createToast(Object.keys(validation_messages).map(key => validation_messages[key]).join(', '), "error");
            }
            LogError.add(e, {
                title: 'Fehler bei der Newsletter-Anmeldung!',
                error_code: 'SubscribeToNewsletterForm.tsx:handleSubmit',
                request_data: { formValues, responseData: e.responseData }
            });
        }).finally(() => {
            onSubmit();
        });
    }

    const onSwitchChange = (ev) => {
        const value = ev.target.checked;
        setWantNewsletter(value);
    };


    const subscriptionDisabled = !formValues['consent_text'] || !(formValues['eigentuemer'] || formValues['erwerben'] || formValues['woechentlich']);


    return <div className={cx(styles.subscribeToNewsletterForm, className)}>

        {newsletterId === 'WGL_NEWSLETTER' && (
            <p>
                Schön, dass du dabei bist! Wir möchten dich gerne laufend über Neuerungen aus der Wohnglück-Welt informieren.
            </p>
        )}
        {newsletterId === 'B2B_MAKLER_NEWSLETTER' && (
            <p>
                Schön, dass du dabei bist! Wir möchten dich gerne regelmäßig über Neuerungen aus
                der Wohnglück.de-Welt informieren. In unserem Newsletter für Immobilienprofis
                erhältst du aktuelle Einblicke in die Produktentwicklung, Tipps zur Vermarktung
                deiner Immobilien und News rund um die Immobilienwelt.
            </p>
        )}
        <p>
            <b>Melde dich optional zu unserem Newsletter an!</b>
        </p>
        <form onSubmit={handleSubmit}>

            {formError(validationMessages.email)}

            {newsletterId === 'WGL_NEWSLETTER' && ( 
                <p>Ja, ich abonniere den wöchentlichen Newsletter von Wohnglück.de und bin mit der unten
                    beschriebenen Nutzung meiner Daten* einverstanden. Diese Einwilligung kann
                    jederzeit und ohne Angabe von Gründen mit Wirkung für die Zukunft widerrufen
                    werden. Weitere Informationen über die Verarbeitung meiner Daten finde ich
                    in der <a href="https://wohnglueck.de/info/datenschutz" target="_blank">Datenschutzerklärung</a>.</p>
            )}

            {newsletterId === 'B2B_MAKLER_NEWSLETTER' && (
                <Switch 
                    className={styles.wantNewsletter}
                    required 
                    checked={wantNewsletter} 
                    onChange={onSwitchChange}
                    label="Ja, ich abonniere den Makler-Newsletter von Wohnglück.de  und bin damit einverstanden, dass meine Daten für den regelmäßigen Versand 
                    des Newsletters über folgende Inhalte verarbeitet werden: Tipps zur Immobilienvermarktung, aktuelle Einblicke in die Produktentwicklung, 
                    Produktneuheiten, News rund um die Immobilienwelt, Angebote und Services auf Wohnglück.de  und unserer Partnerunternehmen. 
                    Weiterhin willige ich ein, dass zum Zwecke der Verbesserung der Nutzerfreundlichkeit, der Angebote und der Werbemaßnahmen 
                    Daten über mein Leseverhalten (Zeitpunkt des Öffnens, der Klicks; geklickte Inhalte; Verweildauer im Newsletter; Standort) 
                    und Geräteinformationen verarbeitet werden sowie, dass zur Anzeige, Abrechnung und Optimierung von Werbemaßnahmen der Werbepartner 
                    meine IP-Nummer, Geräteinformationen, Zeitstempel und Newsletter/Kampagne an diese übermittelt werden. 
                    Diese Einwilligung kann jederzeit und ohne Angaben von Gründen mit Wirkung für die Zukunft widerrufen werden."
                />
            )}

            <div className={styles.actions}>
                {showNextButton && <Button type="reset" onClick={onCancel} variant="outlined">weiter ohne Newsletter</Button>}
                <Button type="submit" color="primary">Anmelden</Button>
            </div>

            {newsletterId === 'WGL_NEWSLETTER' && ( 
                <p className={styles.asterisk}>
                    *Datennutzung: Meine Daten werden für den regelmäßigen (i.d.R. wöchentlichen) Versand des Newsletters über folgende 
                    Inhalte verarbeitet:
                    Top-Artikel, Angebote und Services auf Wohnglück Informationen rund um Ver-/Kauf, Bau, Bewertung und Modernisierung von Immobilien,
                    sowie Angebote unserer Werbepartner. Weiterhin willige ich ein, dass zum Zwecke der Verbesserung der Nutzerfreundlichkeit,
                    unserer Angebote und unserer Werbemaßnahmen Daten über mein Leseverhalten
                    (Zeitpunkt des Öffnens, der Klicks; geklickte Inhalte; Verweildauer im Newsletter; Standort) 
                    und Geräteinformationen verarbeitet werden sowie, dass zur Anzeige, Abrechnung und 
                    Optimierung von Werbemaßnahmen unserer Werbepartner meine IP-Nummer, Geräteinformationen, 
                    Zeitstempel, Newsletter/Kampagne an diese übermittelt werden.
                </p>
            )}
            <p>
                Hinweis: Unsere Datenschutzhinweise finden sich <a href="/info/datenschutz" target="_blank">hier</a>. Eine Abmeldung kannst du jederzeit über den Link im jeweiligen Newsletter vornehmen,
                oder per Mail an <a href="mailto:service@wohnglueck.de">service@wohnglueck.de</a>.
            </p>

        </form>


    </div>
};

const formError = (error: string) => {
    return error && <span className={styles.error}>{error}</span>
}

export default SubscribeToNewsletterForm;
